// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2funQ","inputWrap":"Table_inputWrap__19wla","col":"Table_col__2GCud","bmiTooltip":"Table_bmiTooltip__3YCdR"};